// ABOUTME: Hook loading what applying a delete run removes (GET /runs/:runId/delete-impact), each object counted once.
// ABOUTME: Loads when given a run id (the confirmation opening) and drops the answers of older requests.

import { useEffect, useRef, useState } from 'react';

import { getDeleteImpact } from '../api/findReplaceApi';
import { DeleteImpactDto } from '../types';

export function useDeleteImpact(runId: string | null) {
    const [impact, setImpact] = useState<DeleteImpactDto | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const requestId = useRef(0);

    useEffect(() => {
        requestId.current += 1;
        const thisRequest = requestId.current;
        setImpact(null);
        setError(null);
        if (!runId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        getDeleteImpact(runId)
            .then(data => {
                if (thisRequest === requestId.current) setImpact(data);
            })
            .catch(e => {
                if (thisRequest === requestId.current) {
                    setError(e instanceof Error ? e : new Error(String(e)));
                }
            })
            .finally(() => {
                if (thisRequest === requestId.current) setLoading(false);
            });
    }, [runId]);

    return { impact, loading, error };
}
